import { isEmpty } from '../utils/string'

export type OptionValue<T> = string | number | boolean | T

export type Option<T extends OptionValue<any> = OptionValue<any>> = {
  _type?: string
  label: string
  value: T
}

export function filterOptions<T extends OptionValue<any>>(
  options: Array<Option<T>>,
  values: Array<T> = []
): Array<Option<T>> {
  return options.filter(({ value }) => values.includes(value))
}

export function mapToOptions<T, V extends OptionValue<any>>({
  values,
  getValue,
  getLabel,
  sort = true,
}: {
  values: Array<T>
  getValue: (value: T) => V
  getLabel: (value: T) => string
  sort?: boolean
}): Array<Option<V>> {
  let result = values
    .map(value => ({ label: getLabel(value), value: getValue(value) }))
    .filter(({ label }) => !isEmpty(label))

  if (sort) {
    result = result.sort((a, b) => {
      if (a.label > b.label) {
        return 1
      } else if (a.label < b.label) {
        return -1
      } else {
        return 0
      }
    })
  }

  return result
}
